// @flow
import React from "react";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import CONFIG from "../../../config";
import logoEn from "../../../images/logo/seller-lab-logo.svg";
import logoAr from "../../../images/logo/seller-lab-logo-arabic.svg";
import Button from "../button/Button";
import Icon from "../Icon";
import styles from "./Landing.scss";

const Landing = props => {
  const { user, headerText, subHeader } = props;

  const noSeller = (
    <div>
      {user ? <p className={styles.headerText}>{headerText || ""}</p> : ""}
      <p className={styles.headerText}>{subHeader}</p>
      {noSeller ? (
        <div>
          <a href={`${Helper.getLoginURL()}/${Helper.getLang()}/register`}>
            <Button className={styles.btn}>
              {I18n.getText("landing.register", {}, "Register")}
            </Button>
          </a>
          <p className={styles.headerText}>
            {I18n.getText("landing.or", {}, "or")}
          </p>
          <p className={styles.headerText}>
            {I18n.getText(
              "landing.header-already",
              {},
              "If you are an existing seller,"
            )}
          </p>
        </div>
      ) : (
        ""
      )}
      <Button
        className={styles.btn}
        variant="transparent"
        onClick={() => props.signout()}
      >
        {I18n.getText("landing.logout", {}, "Logout & Sign In")}
      </Button>
    </div>
  );

  const suspendedText = (
    <div>
      <h4 className={styles.suspendedText}>
        {I18n.getText(
          "landing.suspended",
          {},
          "It seems your noon store has been suspended"
        )}
        {props.reason ? (
          <div>
            {I18n.getText("landing.reason", {}, "Reason: ")}
            &nbsp;
            {props.reason}
          </div>
        ) : (
          ""
        )}
      </h4>

      <p className={styles.subText}>
        {I18n.getText(
          "landing.suspended-sub",
          {},
          "If you feel that this account suspension is an error, please reach out to us."
        )}
      </p>
    </div>
  );

  return (
    <div className={styles.ctr}>
      {props.banned && props.seller ? (
        <div className={styles.profile}>
          <div className={styles.menu}>
            <div className={styles.name}>{props.seller.firstName}</div>
            <div className={styles.storeName}>{props.seller.storeName}</div>
          </div>
          <Button
            className={styles.btn}
            variant="transparent"
            onClick={() => props.signout()}
          >
            {I18n.getText("landing.logout-sm", {}, "Logout")}
          </Button>
        </div>
      ) : (
        ""
      )}
      <div className={styles.inner}>
        <div className={styles.logoWrapper}>
          <div className={styles.logoImg}>
            <img src={props.lang === "ar" ? logoAr : logoEn} alt="noon en" />
          </div>
        </div>
        {user ? noSeller : ""}
        {props.banned ? suspendedText : ""}
        <div className={styles.contactCtr}>
          <div className={styles.contacts}>
            <div className={styles.icon}>
              <Icon name="globe" />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.title}>
                {I18n.getText("landing.help", {}, "Help Centre")}
              </div>
              <a
                href={
                  props.lang === "ar" ? CONFIG.SUPPORT_AR : CONFIG.SUPPORT_EN
                }
                target="_blank"
                className={styles.subContact}
              >
                help.noon.com
              </a>
            </div>
          </div>
          <div className={styles.contacts}>
            <div className={styles.icon}>
              <Icon name="envelope" />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.title}>
                {I18n.getText("landing.email", {}, "Email Support")}
              </div>
              <a
                href={`mailto: ${CONFIG.CONTACT_EMAIL}`}
                className={styles.subContact}
              >
                {CONFIG.CONTACT_EMAIL}
              </a>
            </div>
          </div>
          <div className={styles.contacts}>
            <div className={styles.icon}>
              <Icon name="phone" />
            </div>
            <div className={styles.contactDetails}>
              <div className={styles.title}>
                {I18n.getText("landing.phone", {}, "Phone Support")}
              </div>
              <a
                href={`tel: ${
                  props.seller && props.seller === "SA"
                    ? CONFIG.PHONE_NUMBER_KSA
                    : CONFIG.PHONE_NUMBER
                }`}
                className={styles.subContact}
              >
                {props.seller && props.seller === "SA"
                  ? CONFIG.PHONE_NUMBER_KSA
                  : CONFIG.PHONE_NUMBER}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Landing.propTypes = {};

Landing.getDefaultProps = {};

export default Landing;



// WEBPACK FOOTER //
// ./src/components/common/landing/Landing.js